module.exports = __webpack_public_path__ + "media/images/clients/e-pay-9c6234a4f11ff7f257b2c94ba6a8bd05.svg";